import UrlParse from 'url-parse';
import cookies from 'js-cookie';

export interface IAdvCodeName {
    advCodeName: string;
    advDefaultValue?: string;
}

export const ADV_DEFAULT_VALUE = 'alfasite';

// Поиск `advCodeName` в location, потом в cookie
export const getAdvCode = ({
    advCodeName,
    advDefaultValue = ADV_DEFAULT_VALUE,
}: IAdvCodeName): string => {
    const location = typeof window === 'undefined' ? null : window.location;

    // Поиск `advCodeName` в location
    if (location) {
        const { query } = new UrlParse(location.href, {}, /* включаем парсинг querystring */ true);

        const advCodeValue = query[advCodeName];

        if (advCodeValue) {
            return advCodeValue;
        }
    }

    // Поиск `advCodeName` в cookies
    const advCodeValue = cookies.get(advCodeName);

    if (advCodeValue) {
        return advCodeValue;
    }

    // В location и cookies не нашли, отдаём дефолтное значение
    return advDefaultValue;
};
